import { SpinnerContainer, SpinnerOverlay } from "./spinner.style";

const Spinner = () => (
  <SpinnerOverlay>
    <SpinnerContainer></SpinnerContainer>
  </SpinnerOverlay>
);

export default Spinner;
